<template>
    <v-card class="round-card background-2 mb-4">
        <v-card-title class="pa-3">
            <v-icon color="orange" class="mr-3">mdi-lock</v-icon>
            <p>Nota Privata</p>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
            <v-form ref="form">
                <div class="mb-3">
                    <label class="v-label mb-2 d-block">Testo nota</label>
                    <tinymce-editor
                        :editor-id="'private-comment-text'"
                        v-model="form.text"
                    />
                </div>
            </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="pa-3">
            <v-spacer></v-spacer>
            <v-btn text @click="$emit('cancel')" :disabled="saving">
                Annulla
            </v-btn>
            <v-btn
                color="orange"
                @click="saveComment"
                :loading="saving"
                :disabled="!form.text"
            >
                <v-icon left>mdi-content-save</v-icon>
                Salva Nota
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'PrivateCommentForm',

    props: {
        ticketId: {
            type: Number,
            required: true
        }
    },

    data() {
        return {
            saving: false,
            form: {
                text: ''
            }
        }
    },

    methods: {
        async saveComment() {
            this.saving = true
            try {
                await this.axios.post('comments', {
                    commentable_id: this.ticketId,
                    commentable_type: 'helpdesktrouble',
                    type: 'comment',
                    text: this.form.text
                })
                this.$emit('saved')
                this.form.text = ''
            } catch (error) {
                console.error('Error saving comment:', error)
                this.$store.commit('setSnackbarError')
            } finally {
                this.saving = false
            }
        }
    }
}
</script>
